var map = {
	"./IT_consulting.svg": [
		665,
		665
	],
	"./audit.svg": [
		887,
		887
	],
	"./full_stack_dev.svg": [
		270,
		270
	],
	"./integration_api.svg": [
		421,
		421
	],
	"./marketing.svg": [
		517,
		517
	],
	"./migrations.svg": [
		608,
		608
	],
	"./ongoing.svg": [
		732,
		732
	],
	"./simplify.svg": [
		316,
		316
	],
	"./software_automation.svg": [
		309,
		309
	],
	"./software_engineering.svg": [
		210,
		210
	],
	"./software_icon.svg": [
		899,
		899
	],
	"./system_simplification.svg": [
		679,
		679
	],
	"./tech_audit.svg": [
		334,
		334
	],
	"./web_dev.svg": [
		686,
		686
	],
	"./website_audit.svg": [
		358,
		358
	],
	"./website_security.svg": [
		382,
		382
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 907;
module.exports = webpackAsyncContext;